import Vue from "vue";
export default {
  // GET_USER(state, payload) {
  //   state.user = payload;
  // },
  GET_COMPANY_DASH(state, payload) {
    state.get_company_detail = payload;
  },

  ADD_BOOKING(state, payload) {
    state.get_company_detail.unshift(...payload);
  },
  DELETE_Dash_Details(state, payload) {
    const index = state.get_company_detail.findIndex(
      (page) => page._id === payload._id
    );
    state.get_company_detail.splice(index, 1);
  },
  EDIT_DASH_DETAILS(state, payload) {
    state.edit_dash = payload;
  },
};
